<template>
  <div class="main d-table px-2 py-6 bg">
    <v-row>
      <v-col :cols="12" :md="1">
        <v-img
          class="ml-3 mb-2 mt-2 pointer float-left"
          width="100"
          src="../../assets/logo-white.svg"
        ></v-img
      ></v-col>
      <v-col :cols="12" :md="11">
        <p class="float-left ml-md-14">
          O sistema de apoio à decisão do centro de informática (SACI)
          é um sistema web que oferece ferramentas de otimização para
          automatizar e tornar mais eficiente o planejamento acadêmico
          na universidade.
        </p></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AboutSACI"
};
</script>

<style scoped>
.main {
  width: 100%;
  color: white;
  border-radius: 6px;
}

.bg {
  background: linear-gradient(
    45deg,
    #0088ff,
    #2f7dc2,
    #3b3dc9,
    #0088ff
  );
  background-size: 600% 100%;
  animation: gradient 6s linear infinite;
  animation-direction: alternate;
}

@keyframes gradient {
  0% {
    background-position: 0%;
  }
  100% {
    background-position: 100%;
  }
}
</style>
